import { HELPER } from '@cms/tpl';
import { API_PATHS } from 'common';
const API = API_PATHS.INVALID_MEDIA_REVENUE;
const Service = {
  getTotal: (params) => HELPER.API.executeGet(`${API.GET.TOTAL}${params}`),
  getPage: (params) => HELPER.API.executeGet(`${API.GET.PAG}${params}`),
};
export default Service;
